import {
  Box,
  FormControlLabel,
  IconButton,
  Radio,
  Slider,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useMediaQuery } from "react-responsive";
import Title from "../title";
import CloseIcon from "@mui/icons-material/Close";
import Files from "react-files";

const PaymentDoc = ({
  data,
  setData,
  payment_note,
  setPayment_note,
}) => {
  const isPortable = useMediaQuery({ query: "(max-width:1200px)" });



  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      setData((prev) => ({ ...prev, payment_document: files[0] }));
    }
  };

  return (
    <div className="logo-container">
      <Title title="Payment Document" />
      <div className="switcher"></div>

      <div className="logo-ways-container">
          <Box
            sx={{
              width: "100%",
              opacity: 1,
              pointerEvents: "auto",
            }}
          >
            <div
              className="custom-logo "
              style={{
                cursor:"pointer",
              }}
            >
              <Files
                onChange={(fileList) => handleFileChange(fileList)}
                onError={(error) => console.error("File upload error:", error)}
                accepts={["image/*"]}
                clickable
                multiple={false}
                maxFileSize={10485760} // 10MB limit
                className="files"
              />
              {data.payment_document ? (
                <div className="selected-logo-container">
                  <img
                    src={URL.createObjectURL(data.payment_document)}
                    alt="Uploaded Logo"
                    className="selected-logo-img"
                  />
                  <IconButton
                    onClick={() => {
                      setData((prev) => ({ ...prev, payment_document: null }));
                    }}
                    className="selected-logo-remove"
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              ) : (
                <Typography variant="body2" className="text-textColor dark:text-darkTextColor">
                  Click to upload a payment document
                </Typography>
              )}
            </div>
          </Box>

          <div
            style={{
              opacity:  1,
              pointerEvents:  "auto",
              cursor:  "auto",
            }}
            className="logo"
          >
            <div className="main-title">
              <Title title="Add Your Note" />
            </div>

            <Box className="main-logo-container">
              <Box className="main-styles-container">
                <TextField
                  fullWidth
                  variant="outlined"
                  name="payment_note"
                  value={payment_note}
                  onChange={(e) => setPayment_note(e.target.value)}
                  placeholder="Type Your Logo Name here"
                  size="small"
                  type={'textarea'}
                />
              </Box>
            </Box>
          </div>

      </div>
    </div>
  );
};

export default PaymentDoc;
